module.exports = __webpack_public_path__ + "static/media/viber.793e45d8.svg";